import { Link } from "react-router-dom";

const TICKER_ITEMS = [
  { title: "Nuova Sabatini: contributi per macchinari e investimenti aziendali", to: "/blog/nuova-sabatini" },
  { title: "ON Invitalia: incentivi per giovani e donne che vogliono fare impresa", to: "/blog/on-invitalia" },
  { title: "Resto al Sud: incentivi per avviare un'attività nel Mezzogiorno", to: "/blog/resto-al-sud" },
  { title: "Smart&Start Italia: incentivi per startup innovative", to: "/blog/smart-start-italia" },
  { title: "Credito ZES Unica: agevolazioni per investimenti nel Mezzogiorno", to: "/blog/zes-unica" },
];

export default function BlogTicker() {
  // duplicate items so the marquee loop is seamless
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS];

  return (
    <div
      data-testid="blog-ticker"
      className="w-full overflow-hidden"
      style={{ backgroundColor: "#0B1F3A" }}
      role="region"
      aria-label="Ultimi articoli del blog"
    >
      <div className="flex whitespace-nowrap bv-ticker-track py-3">
        {items.map((it, i) => (
          <Link
            key={i}
            to={it.to}
            data-testid={`blog-ticker-item-${i % TICKER_ITEMS.length}`}
            className="inline-flex items-center text-white px-6 group"
          >
            <span
              className="text-[12px] tracking-[0.04em] font-medium opacity-95 group-hover:opacity-100"
              style={{ fontFamily: "Inter, system-ui, sans-serif" }}
            >
              {it.title}
              <span className="ml-3 opacity-70 underline-offset-2 group-hover:underline">
                Leggi l'articolo
              </span>
            </span>
            <span className="text-white/40 px-6 select-none" aria-hidden>
              ·
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
